import ConditionError from '../common/ConditionError';
import ConstantFilterWarning from '../common/ConstantFilterWarning';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Box } from 'foundations-components/transitional/components/Box';
import styled from 'foundations-theming/utils';
import ViewerConditionDisplay from './ViewerConditionDisplay';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ViewerConditionDisplayWrapper = styled.div.withConfig({
  displayName: "FiltersDisplayCondition__ViewerConditionDisplayWrapper",
  componentId: "ij1cuz-0"
})(["word-break:break-word;"]);
/**
 * Wrapper for FilterOperatorDisplay.
 *
 * Provides all necessary data and styling.
 */
const FiltersDisplayCondition = props => {
  const {
    condition,
    isFirst,
    parentLogicGroup,
    filterFamily
  } = props;
  const operatorDisplay = /*#__PURE__*/_jsx(TFlex, {
    align: "center",
    justify: "between",
    children: /*#__PURE__*/_jsx(Box, {
      "data-selenium-test": "filters-display-operator-container",
      children: /*#__PURE__*/_jsx(ViewerConditionDisplayWrapper, {
        children: /*#__PURE__*/_jsx(ViewerConditionDisplay, {
          condition: condition,
          filterFamily: filterFamily,
          parentLogicGroup: parentLogicGroup
        })
      })
    })
  });
  return /*#__PURE__*/_jsxs("div", {
    children: [' ', !isFirst && /*#__PURE__*/_jsxs(View, {
      marginBlockStart: "250",
      marginBlockEnd: "250",
      children: [' ', /*#__PURE__*/_jsx(FormattedMessage, {
        message: `customerDataFiltersUI.customerDataFilters.FilterEditorOperatorDisplayList.and`
      })]
    }), operatorDisplay, /*#__PURE__*/_jsx(ConditionError, {
      condition: condition,
      showConditionErrors: true,
      spaceStyleProps: {
        marginBlockStart: '0'
      }
    }), /*#__PURE__*/_jsx(ConstantFilterWarning, {
      condition: condition
    })]
  });
};
export default FiltersDisplayCondition;